import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import $ from "jquery";
import * as utils from "../../../utils.js";

export default class FormDatosSTJHermana extends Component {
  constructor(props) {
    super(props);
    this.DatosSTJPut = this.DatosSTJPut.bind(this);
  }

  // Función para hacer un put de los datos de STJ
  DatosSTJPut(event) {
    event.preventDefault();
    let $this = $(this);
    let myform = document.getElementById("MyForm");
    let form = new FormData(myform);

    let settings = {
      url: process.env.REACT_APP_API_URL + "/hermanas/" + $this[0].props.DatosMonja.sister.id + "/datosSTJ",
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    // En caso de exito asigna los valores al componente de monja detalle
    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se han editado los datos correctamente", "success");
        response = JSON.parse(response);
        $this[0].props.setDatosHermana(response);
      })
      .fail($this[0].props.ErrorHandling);
  }
  render() {
    // Para obtener la fecha actual para la restriccion html
    let today = utils.calculateDate();
    let form_datos_stj = this.props.DatosMonja.sister ? (
      <Form className=" p-4" onSubmit={this.DatosSTJPut} autoComplete="off" id="MyForm">
        <Form.Group>
          <Form.Row>
            <small className="mb-3">
              Los campos con un <b>*</b> deben de ser rellenados.
            </small>
          </Form.Row>
          <Form.Label>Fecha Ingreso STJ *</Form.Label>
          <Form.Control required max={today} autoComplete="nope" type="date" name="entrySTJ" defaultValue={this.props.DatosMonja.sister.entrySTJ} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Número Compañía *</Form.Label>
          <Form.Control required max="999999" autoComplete="nope" type="number" name="companyNumber" defaultValue={this.props.DatosMonja.sister.companyNumber} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Nombre Compañía *</Form.Label>
          <Form.Control required maxLength="60" autoComplete="nope" type="text" name="companyName" defaultValue={this.props.DatosMonja.sister.companyName} />
        </Form.Group>
        <Form.Group>
          <Button
            type="submit"
            variant="outline-success"
            className="btn btn-block mt-5"
            //onClick={this.props.handleButtonShow} TODO cuando se le da a guardar no se cierra el modal
            name="Datos STJ"
          >
            Guardar
          </Button>
        </Form.Group>
      </Form>
    ) : null;
    return <React.Fragment>{form_datos_stj}</React.Fragment>;
  }
}
